// Single source of truth for the customer-facing company identity
// and shared legal constants. Imported by the footer, every legal
// page, and the checkout legal-notice block.
//
// Identity verified against the current production website
// (www.theherborist.be) on 2026-05-19 — address + RPR + telephone
// stance are confirmed. Remaining TODOs are listed inline.

export const COMPANY = {
  legalName: 'Aquarius Age Company - Belgium Cvba',
  tradeName: 'The Herborist',
  vatNumber: 'BE 0473.582.407',
  // Belgian KBO and VAT are the same number for cvba.
  kbo: 'BE 0473.582.407',
  rpr: 'RPR Dendermonde',
  email: 'info@theherborist.be',
  // Address confirmed from www.theherborist.be (2026-05-19).
  address: {
    street: 'De Pacht 34A',
    postalCode: 'BE-9506',
    city: 'Nieuwenhove',
    country: 'België',
  },
  country: 'België',
  // No phone — confirmed from the current website: "Niet
  // telefonisch bereikbaar". Email is the sole contact channel.
  phone: null,
  phoneNote: 'Niet telefonisch bereikbaar — bereikbaar via e-mail.',
};

export const PRODUCTION_DOMAIN = 'herborist.website';

export const LEGAL_ROUTES = [
  { path: '/algemene-voorwaarden', label: 'Algemene voorwaarden' },
  { path: '/privacy', label: 'Privacybeleid' },
  { path: '/cookies', label: 'Cookiebeleid' },
  { path: '/herroepingsrecht', label: 'Herroepingsrecht' },
  { path: '/verzending', label: 'Verzending & levering' },
  { path: '/contact', label: 'Contact' },
];

// Launch shipping scope — verified against current website
// (www.theherborist.be). The online checkout is intended for these
// countries only; orders to other European countries are accepted
// only after prior confirmation by e-mail. Non-EU is not available
// through the standard checkout.
//
// TODO pre-live: either enforce this scope in the checkout
// `countryCode` validation, or consciously accept broader EU
// checkout with validated shipping / VAT / fulfilment rules.
export const SHIPPING_COUNTRIES_ONLINE = [
  { code: 'BE', name_nl: 'België' },
  { code: 'NL', name_nl: 'Nederland' },
  { code: 'FR', name_nl: 'Frankrijk' },
  { code: 'LU', name_nl: 'Luxemburg' },
];

// Conservative food-supplement disclaimer (KB/AR 29 augustus 1997).
// Used on product detail, cart, checkout, and the legal pages.
export const SUPPLEMENT_DISCLAIMER =
  'Voedingssupplementen zijn geen vervanging voor een gevarieerde, ' +
  'evenwichtige voeding en een gezonde levensstijl. ' +
  'Buiten bereik van jonge kinderen bewaren.';

export const LAST_UPDATED = '19 mei 2026';
